import { ComponentRef } from '@angular/core';
import { DataTableComponent } from '@farris/ui-datatable';
import { TreeNode, TreeTableComponent } from '@farris/ui-treetable';
import { of } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { ComponentInstanceType, LookupGridDisplayType } from '../lookup-displaytype';
import { LookupGridComponent } from '../lookup-grid.component';
import { LookupLeftComponent } from '../lookup-left.component';


export class LookupComponentManager {
    constructor(private ins: LookupGridComponent) {}

    getComponentInstance(type: ComponentInstanceType = 'datatable') {
        if (!this.ins.componentRef || !this.ins.componentRef.instance) {
            return null;
        }

        if (type === 'selected') {
            return this.ins.selectedDtRef;
        }

        let ins = this.ins.componentRef.instance;

        if (type === 'leftDataTable' || type === 'leftTree') {
            const leftRef = this.ins.leftComponentRef;
            if (!leftRef || !leftRef.instance || !leftRef.instance.cmpRef || !leftRef.instance.cmpRef.instance) {
                return null;
            }
            ins = this.ins.leftComponentRef.instance.cmpRef.instance;
        }

        if (type === 'fav') {
            ins = this.ins.favoritesComponentRef.instance;
        }

        switch (type) {
            case 'leftDataTable':
            case 'fav':
            case 'datatable':
                return ins as DataTableComponent;
            case 'leftTree':
            case 'treetable':
                return ins as TreeTableComponent;
            default:
                if (this.ins.isTree()) {
                    return ins as TreeTableComponent;
                }
                return ins as DataTableComponent;
        }
    }

    createComponentWithServerData(data: any) {
        if (this.ins.componentRef) {
            return;
        }
        this.ins.idField = data.idField || this.ins.idField;
        this.ins.textField = data.textField || this.ins.textField;
        this.ins.valueField = data.valueField || this.ins.valueField;

        this.ins.displayType = (data && data.displayType) || this.ins.displayType || 'LIST';

        const dtyp = this.ins.displayType.toUpperCase();

        if (this.ins.isDoublleList()) {
            if (this.ins.navTreeToList && dtyp === LookupGridDisplayType.NavTreeList) {
                this.ins.displayType = LookupGridDisplayType.NavList;
            }

            if (this.ins.treeToList) {
                if (dtyp ===  LookupGridDisplayType.NavListTree) {
                    this.ins.displayType = LookupGridDisplayType.NavList;
                }
            }

        } else {
            if (this.ins.treeToList) {
                if (dtyp === LookupGridDisplayType.TreeList) {
                    this.ins.displayType = 'LIST';
                } else {
                    if (dtyp ===  LookupGridDisplayType.NavListTree) {
                        this.ins.displayType = LookupGridDisplayType.NavList;
                    }
                }
            }
        }

        const isloadall = () => {
            if (this.ins.loadTreeDataType === 'default') {
                return data.treeInfo.loadDataType === 'all'
            } else {
                return this.ins.loadTreeDataType === 'loadall';
            }
        }
 
        const notUsePager = data.treeInfo && (data.treeInfo.layerType === 'parentId' || isloadall());
        if (this.ins.isEnableTreePager() && notUsePager) {
            this.ins.treeTableOptions.pagination = false;
        }
        

        if (this.ins.isDoublleList() && this.ins.navTreeToList) {
            if (dtyp === LookupGridDisplayType.NavTreeList) {
                this.ins.displayType = LookupGridDisplayType.NavList;
            }
        }

        this.ins.changeDetector.detectChanges();

        this.ins.componentRef = this.createContent(this.ins.gridOptions);
        this.createFavoriteComponent();

        this.resizeComponent();
    }


    createFavoriteComponent() {
        if (this.ins.useFavorite && !this.ins.favoritesComponentRef) {
            this.ins.favoriteColumns = this.ins.favHelper.getFavoriteColumns();

            const favoritesOptions = Object.assign({}, this.ins.gridOptions, {
                showFilterBar: false,
                pagination: false,
                columns: this.ins.favoriteColumns || []
            });
            this.ins.favoritesComponentRef = this.createFavoritesContent(favoritesOptions);

            this.resizeComponent('fav');
        }
    }


    private reloadTreeDataForExpand(expandLevel) {
        const uri = this.ins.gridOptions.uri;
        const tt = this.ins.componentRef.instance as TreeTableComponent;
        const { field = '*', value = '' } = {
            ...tt.searchData
        };

        const search = { category: 'all', searchValue: value, searchField: field, layerNum: expandLevel };

        // tfs 657481
        if (tt && tt.sortName) {
            Object.assign(search, {
                sortName: tt.sortName,
                sortOrder: tt.sortOrder
            });
        }

        const param = {
            searchValue: JSON.stringify(search),
            customData: this.ins.customData,
            enableFullTree: this.ins.enableFullTree,
            loadTreeDataType: this.ins.loadTreeDataType
        };


        if (this.ins.helpId) {
            param['helpId'] = this.ins.helpId;
        }


        this.ins.showLoading();
        return this.ins.http.getData(uri, param).subscribe((data: any) => {
            this.ins.closeLoading();
            const nodes = this.ins.checkNodeCanBeSelect(data.items, expandLevel === -1);
            this.ins.items = nodes;
            tt.loadData(nodes);
            tt.psRef.directiveRef.scrollToTop(0);
            // å³é®èåå¨é¨å±å¼åï¼å·²éæ©æ°æ®çå¾éç¶æä¸åç¡®
            this.ins.selectionMgr.selectCurrentValue();
        });
    }

    private setTreeNodeExpandBy(nodes: TreeNode[], level) {
        if (!nodes || !nodes.length) {
            return;
        }
        nodes.forEach((n: TreeNode) => {
            const layer = n.data[this.ins.treeInfo.dataField].layer;

            const expandLayer = layer + level - 1;

            n.expanded = layer <= expandLayer ? true : n.expanded;
            if (n.children && n.children.length && layer + 1 <= expandLayer) {
                this.setTreeNodeExpandBy(n.children, level);
            }
        });
    }

    // å¯ç¨æ å¸®å©å³é®èååè½
    private useContextMenuForTree(cmpRef: ComponentRef<any>) {
        const { maxLevel, enableContextMenu, language } = this.ins.treeTableOptions;
        if (enableContextMenu && maxLevel) {
            const levelMenus = [];
            for (let i = 1; i <= maxLevel; i++) {
                const title = language['expand' + i];
                levelMenus.push({ id: 30 + 1, code: i, title, handle: (t) => {
                    // åéè¯·æ±è·åæ°æ®
                    const level = t.menu.code;
                    if (isLoadAllTreeData() ) {
                        this.setTreeNodeExpandBy(this.ins.items, level);
                        cmpRef.instance.updateSerializedValue();
                    } else {
                        const { dataField, layerField } = this.ins.treeInfo;
                        const firstNodeData = (this.ins.items || [])[0];
                        if (firstNodeData && firstNodeData.data) {
                            const minLayer = this.ins.utils.getValue(`${dataField}.${layerField}`, firstNodeData.data);
                            let _level = minLayer + level - 1;
                            this.reloadTreeDataForExpand(_level);
                        }
                    }
                } });
            }

            const isLoadAllTreeData = () => {
                if (this.ins.loadTreeDataType === 'default') {
                    return cmpRef.instance.loadDataType === 'all';
                } else {
                    return this.ins.loadTreeDataType === 'loadall';
                }
            };

            const showCheckChildNodesMenu = (tn: TreeNode) => {
                if (!tn.selectable && !this.ins.singleSelect) {
                    const visible = tn.children && tn.children.length;
                    if (!visible) {
                        return this.ins.treeInfo.layerType === 'pathcode' && this.ins.isGetAllChidlNodes && !tn.leaf;
                    }
                    return visible;
                }
                return false;
            }

            const updateTreeNodeStatus =(t: any, checked = true) => {

                if (!cmpRef) {
                    return;
                }

                const nodeIds = cmpRef.instance.getChildNodes(t.data.id).filter(n => n.selectable).map(n => n[this.ins.idField]);

                if ((this.ins.cascadeStatus === 'enable'|| this.ins.cascadeStatus === 'up' )&& t.data.parents && t.data.parents.length) {
                    const parentNodeIds = cmpRef.instance.findRowNodes(t.data.parents).filter(n => n.node.selectable).map(n => n[this.ins.idField]);
                    nodeIds.push(...parentNodeIds);
                }

                if (checked) {
                    if (nodeIds && nodeIds.length) {
                        cmpRef.instance.checkedNodes(nodeIds);
                        cmpRef.instance.selectNodes(nodeIds);
                    }
                   
                     // tfs 729771
                     if (this.ins.treeInfo.layerType === 'pathcode' && this.ins.isGetAllChidlNodes) {
                        this.ins.ttEventMgr['updateSelectionsWhenGetAllChildren'](t.data.node, true);
                    }
                } else {
                    if (nodeIds && nodeIds.length) {
                        cmpRef.instance.unCheckedNodes(nodeIds);
                        cmpRef.instance.unSelectNodes(nodeIds);
                    }

                    // tfs 729663
                    if (this.ins.treeInfo.layerType === 'pathcode' && t && t.data && t.data.node ) {
                        let pathcode = this.ins.getPathCode(t.data.node.data, this.ins.treeInfo);
                        if (t.data.parents && t.data.parents.length) {
                            const rootNode = cmpRef.instance.findRowNodes(t.data.parents).filter(n => n.node.selectable);
                            if (rootNode && rootNode.length) {
                                pathcode = this.ins.getPathCode(rootNode[0].node.data, this.ins.treeInfo);
                            }
                        }
                        this.ins.lookupSelectionSer.unselectByPathcode(pathcode);
                    } else {
                        this.ins.lookupSelectionSer.unSelect(nodeIds);
                    }
                }
            }

            const contextMenus = [
                {
                    // 736001
                    id:6, code: 'checkchildnodes', title: language.checkChildNodes,
                    visible: (e) => {
                        // console.log(e);
                        return showCheckChildNodesMenu(e.data.node);
                    },
                    handle: (t) => {
                        updateTreeNodeStatus(t, true);
                    }
                },
                {
                    // 736001
                    id:5, code: 'uncheckchildnodes', title: language.uncheckChildNodes,
                    visible: (e) => {
                        return showCheckChildNodesMenu(e.data.node);
                    },
                    handle: (t) => {
                        updateTreeNodeStatus(t, false);
                    }
                },
                '-',
                {
                    id: 1, code: 'expandall', title: language.expandall, handle: (t) => {
                        if (cmpRef && isLoadAllTreeData()) {
                            cmpRef.instance.expandAll();
                        } else {
                            // åéè¯·æ±è·åæ°æ®
                            this.reloadTreeDataForExpand(-1);
                        }
                    }
                },
                { id: 2, code: 'collapseall', title: language.collapseall, handle: (t) => {
                    if (cmpRef) {
                        cmpRef.instance.collapseAll();
                    }
                } },
                '-',
                {
                    id: 3, title: language.expandByLayer,
                    children: levelMenus
                }
            ];
            this.ins.treeTableOptions.contextMenuItems = contextMenus;

            cmpRef.instance.beforeShowContextMenu = () => {
                // å¯ç¨æ è¡¨åé¡µåæ°åï¼ç¦ç¨å³é®èå
                return of({show: !cmpRef.instance.state.searched && !this.ins.isEnableTreePager()});
            };
        }
    }

    getCmpHeight(isFav = false) {
        return this.ins.dialogMgr.getHeight() - (isFav ? 10 :this.ins.getFilterBarHeight());
    }

    createContent(opts: any): ComponentRef<any> {

        if (this.ins.componentRef) {
            return;
        }

        const type = this.ins.getComponentType();

        const cmpFac = this.ins.cfr.resolveComponentFactory(type);
        let cmpRef: ComponentRef<any> = null;
        if (this.ins.isDoublleList()) {
            cmpRef = this.ins.centerContainer.createComponent(cmpFac);
        } else {
            cmpRef = this.ins.contentContainer.createComponent(cmpFac);
        }

        if (this.ins.isTree()) {
            opts.fit = true;
            opts.pagination = false;
            opts.fast = true;
            opts.fitColumns = false;
            
            this.useContextMenuForTree(cmpRef);
        } else {
            opts.fill = true;
        }
        opts.autoFitColumns = true;

        const ttOpts = this.ins.treeTableOptions || {};
        if (ttOpts.pagination) {
            opts.nodesPagerFixed = true;
        }
        Object.assign(cmpRef.instance, opts, { allColumnsTitle: this.ins.allColumnsTitle, ...ttOpts });

        this.ins.componentRef = cmpRef;
        this.resizeComponent();
        return cmpRef;
    }

    // åå»ºæ¶èCMP
    createFavoritesContent(opts: any): ComponentRef<any> {
        const type = this.ins.getComponentType();
        
        const cmpFac = this.ins.cfr.resolveComponentFactory(type);
        let cmpRef = null;
        cmpRef = this.ins.favoritesContainer.createComponent(cmpFac);
        
        if (this.ins.isTree()) {
            opts.fit = true;
            opts.pagination = false;
        } else {
            opts.fill = true;
        }
        opts.autoFitColumns = true;

        Object.assign(cmpRef.instance, opts, {
            width: this.ins.dialog.size.width - this.ins.getSpaceWidth(),
            height: this.ins.dialogMgr.getHeight()
        });


        // è®¢éæ¶èå¤¹åè¡¨ä¸­ç»ä»¶çç¸å³äºä»¶
        this.ins.favHelper.initFavoriteComponentEvent(cmpRef);

        return cmpRef;
    }

    resizeComponent(type: ComponentInstanceType = 'datatable') {
        const size = {
            width: this.ins.dialog.size.width - this.ins.getSpaceWidth(),
            height: this.getCmpHeight(type == 'fav') 
        };

        if (this.ins.isDoublleList() && (type === 'datatable' || type === 'treetable')) {
            size.width = this.ins.dialog.size.width - this.ins.leftPanelWidth - this.ins.getSpaceWidth(true);
        }

        this.getComponentInstance(type).resize(size);
    }

    private getChildNodes(node: TreeNode) {
        const nodes: any = [];
        if (node.selectable || node.selectable === undefined) {
            nodes.push(node);
        }
        if (node.children && node.children.length) {
            node.children.forEach(n => {
                nodes.push(...this.getChildNodes(n));
            })
        }

        return nodes;
    }

    /** åå»ºå·¦ä¾§ç»ä»¶ */
    createLeftComponent(ops: any) {
        let dtFac = null;
        if (this.ins.isDoublleList()) {
            dtFac = this.ins.cfr.resolveComponentFactory(LookupLeftComponent);
        }
        this.ins.leftComponentRef = this.ins.leftContainer.createComponent(dtFac);
        ops.height = this.ins.dialogMgr.getHeight();

        if (this.ins.dialogWidth < this.ins.navLookupDialogMinWidth) {
            this.ins.dialogWidth = this.ins.navLookupDialogMinWidth;
            this.ins.dialog.reSize({ width: this.ins.dialogWidth });
            this.ins.resizeCmp({ width: this.ins.dialog.size.width });
        }

        // é»è®¤ 1 : 2
        this.ins.leftPanel.resize({
            width: this.ins.leftPanel.width,
            height: ops.height
        });
        this.ins.resizeCmp({ width: this.ins.dialog.size.width });

        // this.resizeComponent();

        this.ins.leftComponentRef.instance.lookupCmp = this.ins;
        this.ins.leftComponentRef.instance.navOptions = ops;

        
        this.ins.leftComponentRef.instance.selected.pipe(
            tap(() => {
                this.ins.showLoading();
            }),
            debounceTime(100),
            switchMap((d: any) => {
                if (d && d.data) {
                    this.ins.navigationFilter = {
                        selected: d.data,
                        idValue: this.getNavigationFilter(d.data),
                        searchField: '',
                        searchValue: ''
                    };
                } else {
                    this.ins.navigationFilter = undefined;
                }
                // å è½½å³ä¾§æ°æ®
                const p = {
                    pageInfo: {
                        pageIndex: 1, // tfs 638840
                        pageSize: this.ins.gridOptions.pageSize
                    }
                };

                if (this.ins.includeSubordinates && d && d.node && ops.treeInfo) {
                    const {layerType, pathField, loadDataType, dataField} = ops.treeInfo
                    if (loadDataType === 'all') {
                        const rowDatas = this.getChildNodes(d.node).map(n => n.data);
                        this.ins.navigationFilter.idValue = this.getNavigationFilter(rowDatas);
                    } else {
                        if (layerType == 'pathcode') {
                            // p['navNodePathCode'] = d.data[dataField][pathField];
                            p['navNodePathCode'] = this.ins.getPathCode(d.data, ops.treeInfo);
                            this.ins['navNodePathCode'] = p['navNodePathCode'];
                        }
                    }
                } else  {
                    this.ins['navNodePathCode'] = '';
                }

                const dataCmpRef = this.getComponentInstance();
                const { sortName, sortOrder } = dataCmpRef;
                Object.assign(p, { search: this.ins._searchState, sortName, sortOrder });
                return this.ins.httpMgr.getData(p, 'list');
            })
        ).subscribe(res => {
            this.ins.closeLoading();
            this.ins.loadDataWhenOpen = true;

            // if (this.ins.useFavorite && !this.ins.isTree()) {
            //     this.ins.favHelper.updateFavoritesStatus(res.items);
            // }
            // this.ins.loadDataTableData(res);
            
            this.ins.loadData(res, false);

            setTimeout(() => {
                // éä¸­æ°æ®
                this.ins.selectionMgr.selectCurrentValue();
                this.ins.changeDetector.detectChanges();
            });
        });

        return this.ins.leftComponentRef.instance.createComponent();
    }

    // è·åå³èæ°æ®, å³ä¾§æ°æ®ä¸­ å³èåå­æ®µçå¼
    private getNavigationFilter(navRow: any) {
        if (this.ins.navigationOptions.relations && this.ins.navigationOptions.relations.length) {
            const result = [];
            this.ins.navigationOptions.relations.forEach(r => {
                const k = r.groupField;
                const dField = r.helpField;
                const rf: any = { fieldName: dField, fieldValue: '' };

                if (Array.isArray(navRow)) {
                    const vals = navRow.map(n => {
                        return k.split('.').reduce((o, c) => {
                            return o[c];
                        }, n);
                    });
                    rf.fieldValue = vals.join(',');
                } else {
                    rf.fieldValue = k.split('.').reduce((o, c) => {
                        return o[c];
                    }, navRow);
                }

                result.push(rf);
            });
            return result;
        }

        return '';
    }
}
